import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const LeakyComponent = ({
  id
}) => {
  useEffect(() => {
    const __newData = Array(1000).fill(null).map((_, index) => ({
      id: `item-${id}-${index}-${Math.random()}`,
      timestamp: new Date().toISOString()
    }));
    const __intervalId = setInterval(() => {
      const leakyListener = () => {};
      window.addEventListener('resize', leakyListener);
    }, 2000);
    return () => {};
  }, [id]);
  return null;
};
const InjectMemoryLeak = () => {
  return /*#__PURE__*/_jsx("div", {
    children: Array(10000).fill(0).map((_, index) => /*#__PURE__*/_jsx(LeakyComponent, {
      id: index
    }, index))
  });
};
export default InjectMemoryLeak;